import React from 'react';
import styled, { css } from 'styled-components';
import { Coupon } from './coupon';
import { formatDateToDot } from '../../../func/func';

interface CouponCardProps {
  coupon: Coupon;
  isUsed: boolean;
  onUseClick: (coupon: Coupon) => void;
}

function CouponCard({ coupon, isUsed, onUseClick }: CouponCardProps) {
  const status = isUsed
    ? '사용완료'
    : coupon.name.includes('할인')
      ? '할인권'
      : coupon.is_possible
        ? '사용가능'
        : '사용불가';
  return (
    <Card>
      <LeftContainer $status={status}>
        <Title $name={coupon.name} $status={status}>
          {coupon.name}
        </Title>
        <Membership $status={status}>{coupon.membership}</Membership>
        <Content>{coupon.description}</Content>
        {coupon.use_time ? (
          <Status>
            사용일
            <span>{formatDateToDot(coupon.use_time)}</span>
          </Status>
        ) : (
          <Status>
            사용기한
            <span>
              {coupon.expire_time
                ? `${formatDateToDot(coupon.expire_time)}까지`
                : '없음'}
            </span>
          </Status>
        )}
      </LeftContainer>
      <CouponButton
        $status={status}
        onClick={() => {
          if (
            isUsed ||
            coupon.use_time ||
            coupon.name.includes('할인') ||
            !coupon.is_possible
          )
            return;
          onUseClick(coupon);
        }}
      >
        {isUsed
          ? '사용완료'
          : coupon.name.includes('할인') || coupon.name.includes('조선멤버십')
            ? '결제단계에서\n사용가능'
            : coupon.is_possible
              ? '사용하기'
              : '사용 불가'}
      </CouponButton>
    </Card>
  );
}

export default CouponCard;

const Card = styled.div`
  width: 100%;
  height: 175px;
  display: flex;
  flex-direction: row;
`;

const LeftContainer = styled.div<{ $status: string | null }>`
  flex: 1;
  padding: 20px 16px;
  border: 1px solid #e1e2e4;
  border-radius: 16px;
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 8px;

  ${({ $status }) => {
    switch ($status) {
      case '사용완료':
        return css`
          background: #fafafb;
        `;
      case '사용불가':
        return css`
          background: #0220470d;
        `;
    }
  }}
`;

const Status = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #616161;
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;

  span {
    color: #222;
  }
`;

const Title = styled.div<{ $name: string; $status: string | null }>`
  font-size: 20px;
  font-weight: 700;
  color: ${({ $status, $name }) => {
    if ($status === '사용완료' || $status === '사용불가') return '#616161';
    return $name.includes('할인') ? '#F45551' : '#008AFF';
  }};
`;

const Membership = styled.div<{ $status: string | null }>`
  font-weight: 500;
  font-size: 16px;
  color: ${({ $status }) => {
    if ($status === '사용완료' || $status === '사용불가') return '#616161';
    return '#222222';
  }};
  margin-bottom: 4px;
`;

const Content = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #616161;
`;

const CouponButton = styled.button<{
  $status: string;
}>`
  display: flex;
  width: 90px;
  padding: 9px 16px;
  justify-content: center;
  align-items: center;
  align-self: stretch;

  border-radius: 16px;
  background: #008aff;
  border: 1px solid #e1e2e4;
  white-space: pre-line;

  color: #fff;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;

  ${({ $status }) => {
    switch ($status) {
      case '사용완료':
        return css`
          background: #f7f7f8;
          color: #37383c29;
          cursor: default;
        `;
      case '할인권':
        return css`
          background: #fff;
          font-size: 14px;
          color: #616161;
          cursor: default;
        `;
      case '사용불가':
        return css`
          background: #0220470d;
          color: #616161;
          cursor: default;
        `;
      case '사용가능':
        return css`
          border-color: transparent;
        `;
    }
  }}
`;
